import { ScrollView, ScrollViewProps } from '@my/ui'

export const KeyboardAwareScrollView = ({ children }: ScrollViewProps) => {
  return <ScrollView contentContainerStyle={{ flex: 1 }}>{children}</ScrollView>
}
